// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"21":"8795a0bd","596":"8795a0bd"}[chunkId] + ".chunk.css";
};